import React from "react";
import "react-popupbox/dist/react-popupbox.css";
import campamento from '../asset/img/diplomas/campamento.jpeg'
import integral from '../asset/img/diplomas/integral.jpeg'
import itEssensials from '../asset/img/diplomas/itEssensial.jpeg'
import oratoria from '../asset/img/diplomas/oratoria.jpeg'
import primerLugar from '../asset/img/diplomas/primerLugar.jpeg'
import robotica from '../asset/img/diplomas/robotica.jpeg'
import routting from '../asset/img/diplomas/routting.jpeg'
import visionario from '../asset/img/diplomas/visionarios.png'
import imgBeca from '../asset/img/diplomas/beca.jpeg'
import fullstack from '../asset/img/diplomas/fullStack.PNG'
import { TwitterTweetEmbed } from 'react-twitter-embed';
import { PopupboxManager, PopupboxContainer } from "react-popupbox";
import scrum from '../asset/img/diplomas/scrum.PNG'

const Outstanding = () => {

  const showFullStack = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={fullstack} alt="Secretaría de presidencia" />
        <div className="mt-2">
        <span className="portafolio-p">Diploma de <b>secretaría de la presidencia de El Salvador</b></span>
        <br />
        <span className="portafolio-p"> por aprobación del curso <b>Desarrollo Full Stack en Javascript.</b></span>
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Diploma de secretaría de innovación de la presidencia como FullStack'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }
  const showScrum = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={scrum} alt="Secretaría de presidencia" />
        <div className="mt-2">
        <span className="portafolio-p">Certificado de finalización de <b>metodología SCRUM</b> por aprobación</span> <br/>
        <span className="portafolio-p">  del curso <b>Scrum Fundamentals.</b></span>
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Curso de metodología SCRUM'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  const showCampamento = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={campamento} alt="Campamento" />
        <div className="mt-2">
        <span className="portafolio-p">Diploma de campamento de informática obtenido en </span>
        <br />
        <span className="portafolio-p"> <b> Universidad politécnica de El Salvador</b></span>
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Diploma obtenido en Universidad politécnica de El Salvador'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  const showIntegral = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={integral} alt="Integral" />
        <div className="mt-2">
        <span className="portafolio-p">Reconocimiento como alumno bachiller integral de promoción.</span>
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Reconocimiento como bachiller integral'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  const showItEssentials = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={itEssensials} alt="Cisco " />
        <div className="mt-2">
        <span className="portafolio-p">Certificado de aprobación de curso It Essentials en plataforma CISCO Networking.</span>
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Certificado como IT essentials de CISCO Networking'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  const showOratoria = () => {
    const content = (
      <><div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <img className="portafolio-image-oratoria" src={oratoria} alt="Oratoria" />
        <div className="portafolio-image-oratoria">
          <TwitterTweetEmbed
            tweetId={'1022533414455525376'}
          />
        </div>
      </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Diploma de oratoria'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  const showFirtsPlace = () => {
    const content = (
      <center>
        <img className="portafolio-image-popupbox" src={primerLugar} alt="1° lugar" />
        <div className="mt-2">
        <span className="portafolio-p">Reconocimiento de primer lugar de promoción como Técnico </span> <br/>
        <span className="portafolio-p">vocacional en Infraestructura Tecnológica y servicios informáticos.</span>
        </div>
      </center>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Reconocimiento como 1° lugar de promoción'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }
  const showVisionario = () => {
    const content = (
      <center>
        <img className="portafolio-image-popupbox" src={visionario} alt="Visionario" />
        <div className="mt-2">
        <span className="portafolio-p">Certificado de finalizacion de programa visionario siendo estudiante destacado </span> <br/>
        </div>
      </center>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Programa visionario dirigido a estudiantes sobresalientes'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  const showFeria = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={robotica} alt="Feria tecnológica" />
        <div className="mt-2">
        <span className="portafolio-p">Diploma por participación destacada en primera feria tecnológica</span> <br/>
        <span className="portafolio-p"> de lógica de programación orientada a robots.</span>
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Diploma por feria tecnológica de lógica de programación orientada a robots.'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }
  const showBecaFantel = () => {
    const content = (
      <div>
        <img className="portafolio-image-beca" src={imgBeca} alt="Beca" />
        <div className="mt-2">
        <span className="portafolio-beca">Acreedor de beca presidencial por parte del <b> gobierno de El Salvador, </b></span> <br/>
        <span className="portafolio-beca">  bajo el subprograma de becas a la excelencia.</span>
        </div>
      </div>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Beca Fantel'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }
  const showCCNA = () => {
    const content = (
      <>
        <img className="portafolio-image-popupbox" src={routting} alt="CCNA " />
        <div className="mt-2">
        <span className="portafolio-p">Certificado de aprobación del curso CCNA Routing and </span> <br/>
        <span className="portafolio-p">  Switching en plataforma CISCO Networking.</span>
        </div>
      </>
    )
    PopupboxManager.open({
      content,
      config: {
        titleBar: {
          enable: true,
          text: 'Certificado como CCNA Routing and Switching de CISCO Networking'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }
    })
  }

  return (
    <section className="ftco-section ftco-project" id="méritos">
      <div className="container-fluid px-md-0">
        <div className="row no-gutters justify-content-center pb-5">
          <div className="col-md-12 heading-section text-center ftco-animate">
            <h1 className="big big-2">Projects</h1>
            <h2 className="mb-4 text-uppercase colorTexto">Méritos destacados</h2>
            <p>Certificaciones, diplomas, acreditaciones, y demas reconocimientos obtenidos.  </p>
          </div>
        </div>
        <div className="row no-gutters">
          <div className="col-md-4 " >
            <div onClick={showFullStack} className="project img ftco-animate d-flex justify-content-center align-items-center portfolio-image-box" style={{ backgroundImage: `url(${fullstack})` }} >
              <div className="overlay"></div>
              <div className="text text-center p-4">
                <h3><a>Diploma de <b>secretaría de la presidencia de El Salvador</b>, por aprobación del curso <b>Desarrollo Full Stack en Javascript.</b></a></h3>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div onClick={showItEssentials} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${itEssensials})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
                <h3><a>Certificado de aprobación de curso It Essentials en plataforma CISCO Networking.</a></h3>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div onClick={showCCNA} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${routting})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
                <h3><a>Certificado de aprobación del curso CCNA Routing and Switching en plataforma CISCO Networking. </a></h3>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div onClick={showBecaFantel} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${imgBeca})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
                <h3><a>Acreedor de beca presidencial por parte del <b> gobierno de El Salvador, </b> bajo el subprograma de becas a la excelencia.</a></h3>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div onClick={showFirtsPlace} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${primerLugar})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
                <h3><a>Reconocimiento de primer lugar de promoción como Técnico vocacional en Infraestructura Tecnológica y servicios informáticos.</a></h3>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div onClick={showIntegral} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${integral})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
                <h3><a>Reconocimiento como alumno bachiller integral de promoción. </a></h3>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div onClick={showOratoria} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${oratoria})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
                <h3><a>Diploma de certamen regional de oratoria presentado en la<b> Universidad Centroamericana José Simeón Cañas. </b></a></h3>
              </div>
            </div>
          </div>

          <div className="col-md-4 " >
            <div onClick={showCampamento} className="project img ftco-animate d-flex justify-content-center align-items-center portfolio-image-box" style={{ backgroundImage: `url(${campamento})` }} >            <div className="overlay"></div>
              <div className="text text-center p-4">
                <h3><a>Diploma de campamento de informática obtenido en <b> Universidad politécnica de El Salvador</b></a></h3>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div onClick={showFeria} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${robotica})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
                <h3><a>Diploma por participación destacada en primera feria tecnológica de lógica de programación orientada a robots. </a></h3>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div onClick={showScrum} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${scrum})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
                <h3><a>Certificado de finalización satisfactoria del curso Scrum Fundamentals. </a></h3>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div onClick={showVisionario} className="project img ftco-animate d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${visionario})` }}>
              <div className="overlay"></div>
              <div className="text text-center p-4">
                <h3><a>Diploma de finalización programa siendo alumno con alto rendimiento </a></h3>
              </div>
            </div>
          </div>
          <PopupboxContainer />
        </div>
      </div>
    </section>
  );
};

export default Outstanding;
